export default __webpack_public_path__ + "static/media/Wishes.5910de2c.png";